import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as Highcharts from 'highcharts';
import { BehaviorSubject, observable, Observable } from "rxjs";
import { finalize, map, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";


@Injectable({
    providedIn: "root",
  })


export class StatisticsService {


  usersListSubject =   new BehaviorSubject<any[]>(null);
  Users$: Observable<any[] > = this.usersListSubject.asObservable();
  userRoleSubject = new BehaviorSubject<any[]>(null);
  userRole$ : Observable<any[]>= this.userRoleSubject.asObservable();
constructor(private http: HttpClient ,private snotifyService: ToastrService,){
  this.getUserUsers()
  this.getRoles().subscribe(res=>
    this.userRoleSubject.next(res))
}
getData(){
  this.getRoles().pipe(tap((res:any)=>
  {
    this.userRoleSubject.next(res)
  }),
    map(res=>{
      return res.map((role)=> ({id : role.id , name :role.name}))
    }),
    // finalize(()=>)

  
  )
}
  



createChart(e1, cfg)
{
  Highcharts.chart(e1,cfg)
}
public getUserUsers() {
  return this.http.get<any>("/Users/GetAll")
    //  this.usersListSubject.next(res)

}
public getUsersList(data){
  return this.http.post<any>( `/users/GetUsersDDL`,data)
}
public getfilterdUsers(request) {
  return this.http.post<any>("/Users/GetList", request)
    //  this.usersListSubject.next(res)
    // return this.http.post<UserListRespone>("/Users/GetList", request);

}
public getUserFlow(request) {
        return this.http.post<any>("/UserDashboard/GetUsersFlow", request);
}

public getUsersNavigations(request) {
               return this.http.post<any>("/UserDashboard/GetUsersByNavigation", request);
}
      // return this.http.get<any>(`/BolgArchive/GetPostByParentId/` + parentId)

      public getUserVisits(UserId) {
        return this.http.get<any>(`/UserDashboard/GetUserVisits/`+ UserId);
      }
      public getUserFlowByVisitId(VisitId) {
        return this.http.get<any>(`/UserDashboard/GetUserFlowByVisitId/`+ VisitId);
      }


      public getRoles() {
        return this.http.get("/RolesManagement/GetRoles").pipe(
          map((res: any[]) => {
            return res.map((x) =>({id : x.id , name : x.name}));
          }),
          tap((res: any[]) => res && this.userRoleSubject.next(res))
        );
      }
public GetUserNavigation(payload){
   return this.http.post<any>("/UserDashboard/GetUserNavigations",payload)

}

openNotifySuccess(message: any) {
  this.snotifyService.success(message, "", {
    timeOut: 2000,
    progressBar: true,
    tapToDismiss: true,
  })
}

openNotifyError(message: string) {
this.snotifyService.error(message, "", {
  timeOut: 2000,
  progressBar: true,
  tapToDismiss: true,
});
}
      // /Users/GetList
  }